module.exports = "pegasus/assets/themelp1/simple/103.png";